
// src/actions/user-settings.js

export const OPEN_USER_SETTINGS_PAGE = "OPEN_USER_SETTINGS_PAGE"

export function openUserSettingsPage(name) {
  return {
    type: OPEN_USER_SETTINGS_PAGE,
    name
  }
}

export const CLOSE_USER_SETTINGS_PAGE = "CLOSE_USER_SETTINGS_PAGE"

export function closeUserSettingsPage() {
  return {
    type: CLOSE_USER_SETTINGS_PAGE,
  }
}




// WEBPACK FOOTER //
// ./src/actions/user-settings.js